<div class="row m-0 p-2">
  <div class="col-md-3 col-sm-4  col-xs-4 col-4 m-0 p-0 pr-1">
    <select [(ngModel)]="selectedSetting" class="w-100" (change)="onChange($event)">
      <option [ngValue]="i" style="font-size: 12px;" *ngFor="let i of retracementList">{{ i.name }}</option>
    </select>
  </div>
  <div style="font-size: 12px;"  class="col-md-3 col-sm-4 col-4 pr-2 col-xs-4 m-0 p-0 pt-2 pb-2 text-right">
    New / Update:
  </div>
  <div class="col-md-3 col-sm-4 col-4  col-xs-3 m-0 p-0">
    <input
    class="w-100"
    style="font-size: 12px;"
      type="text"
      [(ngModel)]="selectedRetracementSettingName"
      name="rate"
    />
  </div>
  <div class="col-md-3 col-sm-4 col-4">
    <input (click)="resetCurrentValues()" style="font-size: 12px;" type="button" value="Reset Selected">
  </div>
</div>
<div
class="pb-3"
  style=" overflow-x: hidden;"
>
  <div class="row">
    <div style="font-size: 12px;" class="col-md-1 col-sm-1 col-1">id</div>
    <div style="font-size: 12px;" class="col-md-2 p-1 col-sm-2 col-2">Value</div>
    <div style="font-size: 12px;" class="col-md-2 p-1 col-sm-2 col-2">Color</div>
    <div style="font-size: 12px;" class="col-md-2 col-sm-1 col-1 p-1">Ext.</div>
    <div style="font-size: 12px;" class="col-md-2 p-1 col-sm-2 col-2">Width</div>
    <div style="font-size: 12px;" class="col-md-2 col-sm-3 col-3 p-1">style</div>
  </div>
    <ng-container *ngFor="let rowitem of levels">
      <div class="row pt-1 pb-0">
        <div class="col-md-1 col-sm-1 col-1">{{ rowitem.id }}</div>
        <div class="col-md-2 p-1 col-sm-2 col-2">
          <input
            class="w-100 input-num"
            type="number"
            step="0.001"
            [value]="rowitem.levelValue"
            (change)="levelUpdate($event, rowitem.id)"
          />
        </div>
        <div class="col-md-2 p-1 col-sm-2 col-2">
          <input
          style="padding:0"
            class="w-100"
            type="color"
            [value]="rowitem.color"
            (ngModel)="(rowitem.color)"
            (change)="colorUpdate($event, rowitem.id)"
          />
        </div>
        <div *ngIf="false" class="col-md-1 col-sm-1 col-1 p-1 text-center">
          <input
            type="checkbox"
            (click)="extendUpdate($event, rowitem.id)"
            [checked]="rowitem.isExtended"
          />
        </div>
        <div *ngIf="true" class="col-md-2 col-sm-3 col-3 p-1">
          <select (change)="extensionTypeUpdate($event, rowitem.id)" class="w-100 input-num">
            <option *ngFor="let styleItem of extensionsWithLables.extensionWitLabels"
            [selected] = "styleItem.extension==rowitem.extensionType"
             [value]="styleItem.extension"
             >{{styleItem.label}}</option>

          </select>
        </div>
        <div class="col-md-2 p-1 col-sm-2 col-2">
          <input
          class="w-100  input-num"
          type="number"
          step="1"
          [value]="(rowitem.width)?rowitem.width:1"
          (change)="widthUpdate($event, rowitem.id)"
        /></div>
        <div class="col-md-2 col-sm-3 col-3 p-1">
          <select (change)="styleUpdate($event, rowitem.id)" class="w-100 input-num">
            <option *ngFor="let styleItem of lineStyles"
            [selected] = "styleItem.value==rowitem.style"
             [value]="styleItem.value"
             >{{styleItem.label}}</option>

          </select>
        </div>
      </div>
    </ng-container>
</div>
